<template>
  <div id="results" class="container flex-grow-1 d-flex flex-column">
    <div class="flex-grow-1 d-flex mt-5 mb-5">
      <div class="row justify-content-center align-self-stretch text-center mb-5">
        <div class="col-sm-8 h-100">
          <div class="d-flex flex-column h-100">
          <h1 class="result_headline text-primary">{{ $t('Congratulations') }}!</h1>
          <div class="result_text" v-html="$t('You have correctly answered <span class=\'text-primary\'>{0} of {1}</span> questions!', [correct_answered, questions_total] )"></div>
          <div class=" pt-4 pb-4 flex-grow-1 d-flex justify-content-center align-items-center flex-column img-items-flex">
            <img src="../assets/matflow_homepage.png" class="d-flex h-100 flex-grow-image">
          </div>
          </div>
        </div>
        <div class="col-sm-12 text-center">
          <div class="result_text align-self-end w-100 font-weight-bold" style="font-size:1.35rem"><a href="http://www.materialflows.net" target="_blank">www.materialflows.net</a> - {{ $t('for a better understanding of the world of raw materials!') }}</div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-end mb-5 ">
      <router-link to="/" class="btn btn-xl btn-primary">{{ $t('Restart quiz') }}</router-link>
      <a href="http://www.materialflows.net" target="_blank" class="btn btn-xl btn-primary ml-auto">{{ $t('Visit materialflows.net') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Results',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      questions: 'getSelectedQuestions',
      correct_answered: 'getCorrectAnswered',
      presentation_mode: 'getPresentationMode'
    })
  },
  created () {
    this.questions_total = this.questions.length
    this.$store.dispatch('setNavTitle', this.$i18n.t('Result', this.$i18n.locale))
    this.$store.dispatch('setNavSubtitle', '')
    this.$store.dispatch('setNavInfo', '')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Results.vue